export default __webpack_public_path__ + "../images/legend-without-acars.svg";